<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="售后申请"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
          <!--   球杆序列号     -->
          <van-field
              readonly
              clickable
              name="number"
              :value="formData.number"
              label="球杆编码"
              placeholder="点击选择球杆编码"
              @click="showPicker = true"
              class="search-input"
              :rules="[{ required: true}]"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
          <!--   原因说明（重点PC端适配）     -->
          <van-field name="checkType" label="原因说明" class="checktype-h"  :rules="[{ required: true, message: '请选择原因说明' }]">
            <template #input>
              <div class="check-type-radio-group">
                <van-radio-group v-model="formData.checkType" direction="horizontal">
<!--                  <van-radio name="保养维护">保养维护</van-radio>-->
<!--                  <van-radio name="木头开裂">木头开裂</van-radio>-->
<!--                  <van-radio name="铜头松动">铜头松动</van-radio>-->
<!--                  <van-radio name="球杆调直">球杆调直</van-radio>-->
<!--                  <van-radio name="其它原因">其它原因</van-radio>-->
                  <van-radio name="皮头起层脱落">皮头起层脱落</van-radio>
                  <van-radio name="先角松动">先角松动</van-radio>
                  <van-radio name="球杆异响">球杆异响</van-radio>
                  <van-radio name="铜箍松动">铜箍松动</van-radio>
                  <van-radio name="严重弯曲">严重弯曲</van-radio>
                  <van-radio name="漆面起泡">漆面起泡</van-radio>
                  <van-radio name="接牙错位">接牙错位</van-radio>
                </van-radio-group>
              </div>
            </template>
          </van-field>
          <!--   原因说明描述     -->
          <van-field
              v-model="formData.description"
              name="description"
              rows="2"
              autosize
              label=""
              type="textarea"
              placeholder="请输入问题描述（选填）"
          />
          <van-field name="fileList" label="问题图片" class="checktype-img" :rules="[{ required: true, message: '请上传问题图片' }]">
            <template #input>
              <van-uploader v-model="fileList" multiple :max-count="3" />
            </template>
          </van-field>
          <van-field v-model="formData.userName" name="userName" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true }]" />

          <van-field v-model="formData.telephone" name="telephone" label="电话" placeholder="请输入您的电话" :rules="[{ validator:telValidator }]"/>

          <van-field
              readonly
              clickable
              name="area"
              :value="provinceValue"
              label="地址"
              placeholder="点击选择省市区"
              @click="showArea = true"
              :rules="[{ required: true }]"
          />
          <van-popup v-if="showArea" v-model="formData.province" position="bottom">
            <van-area
                :area-list="areaList"
                @confirm="onCityConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <van-field v-model="formData.detailAddr"
                     name="detailAddr"
                     rows="1"
                     autosize
                     type="textarea"
                     label="详细地址"
                     placeholder="请输入您的详细地址"
                     :rules="[{ required: true }]"
          />

          <div style="margin: 16px;">
            <van-button class="submit-btn" round block type="info" native-type="submit">提交申请</van-button>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {afterPost, productByUser} from "@/api/sales";
import {Dialog} from "vant";
import { areaList } from '@vant/area-data';

export default {
  data(){
    return {
      // 表单数据 - 核心修复：单选框绑定值改为字符串（数组会导致选中异常+样式错乱）
      formData: {
        number: "",
        checkType: "", // 从数组[]改为字符串""，适配单选框逻辑
        description: "",
        userName: "",
        telephone: "",
        province: "",
        city: "",
        detailAddr: "",
      },
      selectOptions: [],
      showPicker: false,
      provinceValue: '',
      showArea: false,
      areaList,
      fileList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    telValidator(val) {
      if(val){
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(val)) {
          return false;
        }
      }else{
        return false;
      }
    },
    onSubmit(values){
      const formData = new FormData();

      formData.append('number', values.number);
      formData.append('checkType', values.checkType);
      formData.append('description', values.description);
      formData.append('userName', values.userName);
      formData.append('telephone', values.telephone);
      formData.append('address', values.area.replaceAll('/','')+values.detailAddr);

      const files = [];
      this.fileList.forEach(item => {
        if (item.file) {
          files.push(item.file);
          formData.append('rImg', item.file);
        }
      });

      afterPost(formData).then(res => {
        if(res.code==200){
          const data = res.data;
          if (data.code == 1) {
            this.showDialogMsg(data.returnMsg);
            this.formData= {
              number: "",
              checkType: "", // 同步改为字符串
              description: "",
              userName: "",
              telephone: "",
              province: "",
              city: "",
              detailAddr: "",
            }
            this.fileList = []; // 新增：重置文件列表
          }else if(data.code ==0) {
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==2){
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==3){
            this.showDialogMsg(data.returnMsg);
          }else if(data.code ==4){
            this.showDialogMsg(data.returnMsg);
          } else if(res.data.code ==0){
            this.showDialogMsg(data.returnMsg);
          }
        }else{
          this.showDialogMsg(res.data?.returnMsg || '提交失败，请稍后重试'); // 容错处理
        }
      }).catch(err => {
        this.showDialogMsg('网络异常，提交失败，请稍后重试'); // 新增异常捕获
      });
    },
    onClickLeft() {
      this.$router.push('/app_home');
    },
    onConfirm(value) {
      this.formData.number = value;
      this.showPicker = false;
    },
    onCityConfirm(values){
      this.provinceValue = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');
      this.showArea = false;
    },
    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true,
        // PC端弹窗适配
        style: { width: '90%', maxWidth: 'none' }
      });
    },
    selectProductByUser(){
      productByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            dangerouslyUseHTMLString: true,
            style: { width: '90%', maxWidth: 'none' }
          }).then(() => {});
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取球杆编码失败，请稍后重试',
          dangerouslyUseHTMLString: true,
          style: { width: '90%', maxWidth: 'none' }
        });
      })
    },
  }
}
</script>

<style scoped lang="scss">
// 继承公共样式的黑金主题色变量
$black: #000000;
$gold: #D4AF37;
$dark-gold: #B8860B;

::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}

// ################### 核心：原因说明PC端适配 ###################
// 单选组外层容器（统一控制PC/移动端）
.check-type-radio-group {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap; // 移动端换行
  min-height: 42px; // 匹配公共样式中van-field的PC端高度

  // PC端适配核心规则
  @media (min-width: 768px) {
    flex-wrap: nowrap !important; // 强制单行显示
    overflow: hidden; // 防止溢出
    height: 42px; // 严格匹配公共样式的field高度
    line-height: 42px; // 垂直居中

    // PC端单选框样式适配
    ::v-deep .van-radio--horizontal {
      margin-bottom: 0 !important; // 取消上下间距
      margin-right: 25px !important; // 合理的左右间距
      flex-shrink: 0; // 禁止压缩
      font-size: 15px !important; // 匹配公共样式的字体大小

      // PC端单选按钮尺寸适配
      .van-radio__icon {
        width: 18px !important;
        height: 18px !important;
        margin-right: 8px !important;
        vertical-align: middle;
      }

      // 选中状态对勾适配
      .van-radio__icon--checked .van-icon {
        font-size: 12px !important;
        line-height: 18px !important;
      }
    }
  }
}

// 移动端单选框样式（保留原有逻辑）
.van-radio--horizontal{
  margin-bottom: 10px;
}
// ###########################################################

// 导航栏样式（匹配公共样式的黑金渐变）
.top-bar{
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
}

// 容器适配（匹配公共样式的PC端50%宽度）
.container-item {
  margin-bottom: 60px;
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 100px; // 匹配公共样式的间距
  }
}

// 表单容器适配
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
  @media (min-width: 768px) {
    padding: 20px;
    border-radius: 12px;
    margin: 20px auto;
    width: calc(100% - 40px);
    background: #fff;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
}

// 提交按钮（匹配公共样式的黑金渐变）
.submit-btn{
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  border: none;
  @media (min-width: 768px) {
    height: 80px; // 匹配公共样式的按钮高度
    font-size: 36px; // 匹配公共样式的按钮字体
    border-radius: 8px;
    &:hover {
      background: $dark-gold;
    }
  }
}

// 修复PC端原因说明字段的高度对齐
::v-deep .van-field {
  @media (min-width: 768px) {
    &[name="checkType"] {
      height: 42px !important; // 强制匹配公共样式高度
      line-height: 42px !important;
    }
  }
}
::v-deep .van-radio__icon{
  @media (min-width: 768px) {
    font-size: 18px;
  }
}
.checktype-h{
  @media (min-width: 768px) {
    height: 150px;
  }
}

// ################### 核心修复：PC端预览图超界问题 ###################
.checktype-img {
  @media (min-width: 768px) {
    // 1. 基础容器适配：保证高度+不溢出
    min-height: 150px !important;
    height: auto !important;
    padding: 10px 0 !important;
    overflow: visible !important;

    // 2. 字段内容区适配
    ::v-deep .van-field__control {
      height: auto !important;
      min-height: 130px;
      padding: 0 !important;
      width: 100% !important; // 强制占满容器宽度
      box-sizing: border-box !important;
    }

    // 3. Uploader容器：横向滚动+尺寸控制（核心解决超界）
    ::v-deep .van-uploader {
      width: 100% !important;
      padding: 10px 0;
      display: flex !important;
      flex-wrap: nowrap !important; // 强制单行
      overflow-x: auto !important; // 横向滚动，不超界
      overflow-y: hidden !important;
      gap: 10px !important; // 统一间距，替代margin
      box-sizing: border-box !important;
      scrollbar-width: thin; // 美化滚动条（Firefox）

      // 滚动条样式优化（Chrome/Safari）
      &::-webkit-scrollbar {
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $gold;
        border-radius: 3px;
      }

      // 4. 上传按钮：缩小尺寸适配容器
      .van-uploader__upload {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩
        margin: 0 !important; // 取消margin，用gap控制间距
        font-size: 14px !important;
      }

      // 5. 预览图：缩小尺寸+禁止压缩
      .van-uploader__preview {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩，避免变形
        margin: 0 !important; // 取消margin，用gap控制间距
        position: relative;
      }
      .van-uploader__preview-image{
        width: 100px !important;
        height: 100px !important;
      }

      // 6. 预览图删除按钮：适配缩小后的预览图
      .van-uploader__preview-delete {
        width: 20px !important;
        height: 20px !important;
        font-size: 12px !important;
        top: 5px;
        right: 5px;
      }
    }
  }
}

// 移动端保持原有逻辑（不影响）
::v-deep .van-uploader {
  @media (max-width: 767px) {
    flex-wrap: wrap !important;
    overflow-x: visible !important;
  }
}
// ###########################################################
</style>